module.exports = __webpack_public_path__ + "media/images/banner-assets/en/banner4-be4a452bde4e4b16dc2be6fcd52a2a04.jpg";